module.exports = __webpack_public_path__ + "static/dcom2-150x150-adc28aa10c9ff6157948962d158131fc.png";